import { createRouter, createWebHistory } from 'vue-router';
import LineSelectionPage from '@/features/lines/LineSelectionPage.vue';
import DepartureSelectionPage from '@/features/departures/DepartureSelectionPage.vue';
import MpcStatisticsPage from '@/features/statistics/MpcStatisticsPage.vue';
import DailyStatisticsView from '@/features/statistics/DailyStatisticsView.vue';
import MonthlyStatisticsView from '@/features/statistics/MonthlyStatisticsView.vue';
import ExportStatisticsView from '@/features/statistics/ExportStatisticsView.vue';
import DriverMessagesPage from '@/features/messages/DriverMessagesPage.vue';
import TripPage from '@/features/trips/TripPage.vue';
import BookingLogPage from '@/features/trips/BookingLogPage.vue';

const router = createRouter({
    history: createWebHistory('/mpc/'),
    routes: [
        {
            path: '/',
            name: 'home',
            component: LineSelectionPage
        },
        {
            path: '/bookinglog',
            name: 'bookingLog',
            component: BookingLogPage
        },
        {
            path: '/mpcstatistics',
            component: MpcStatisticsPage,
            children: [
                { path: '', redirect: { name: 'mpcStatisticsDaily' } },
                { path: 'daily', name: 'mpcStatisticsDaily', component: DailyStatisticsView },
                { path: 'monthly', name: 'mpcStatisticsMonthly', component: MonthlyStatisticsView },
                { path: 'export', name: 'mpcStatisticsExport', component: ExportStatisticsView }
            ]
        },
        {
            path: '/messages/:lineNumber/:tripId',
            name: 'messages',
            component: DriverMessagesPage,
            props: true
        },
        {
            path: '/:lineNumber',
            name: 'departures',
            component: DepartureSelectionPage,
            props: true
        },
        {
            path: '/:lineNumber/:tripId/:stopIndex',
            name: 'trip',
            component: TripPage,
            props: true
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (!to.query.token && from.query.token) {
        next({
            ...to,
            query: {
                token: from.query.token,
                view: from.query.view,
                ...to.query
            }
        });
    } else {
        next();
    }
});

export default router;
